module.exports = __webpack_public_path__ + "img/default-cover.662eee4c.png";